import React, { useState } from 'react';
import cn from 'classnames';
import SharedExplanation from '@/Framework/UI/Atoms/Explanation';
import IconQuestion from '@dealroadshow/uikit/core/components/Icon/IconQuestion';
import styles from './explanation.scss';

interface IExplanation {
  content: React.ReactNode,
  wrapperClassName?: string,
  className?: string,
  contentClassName?: string,
  iconClassName?: string,
  isClickable?: boolean,
  dataTestPrefix?: string,
}

const Explanation = (props:IExplanation) => {
  const {
    isClickable = true,
    wrapperClassName = '',
    content,
    className = '',
    contentClassName = '',
    iconClassName = '',
    dataTestPrefix = '',
  } = props;
  const [isVisible, setIsVisible] = useState(false);

  const handleClick = () => {
    // repaint popup modal
    if (!isVisible) {
      window.dispatchEvent(new Event('resize'));
    }

    setIsVisible((prev) => !prev);
  };

  const handleMouseEnter = () => (
    isClickable
      ? false
      : setIsVisible(true)
  );

  const handleMouseLeave = () => (
    isClickable
      ? false
      : setIsVisible(false)
  );

  return (
    <SharedExplanation
      content={ content }
      dataTest={ dataTestPrefix }
      hide={ handleClick }
      isVisible={ isVisible }
      wrapperClassName={ cn(styles.wrapper, wrapperClassName) }
      className={ cn(styles.popover, className) }
      contentClassName={ cn(styles.content, styles.relative, contentClassName) }
    >
      <IconQuestion
        className={ cn(styles.icon, iconClassName, {
          [styles.isClickable]: isClickable,
        }) }
        onClick={ handleClick }
        onMouseEnter={ handleMouseEnter }
        onMouseLeave={ handleMouseLeave }
      />
    </SharedExplanation>
  );
};

export default Explanation;
